class CartValidator {
  constructor() {
    // Detect if the site is in English based on the hostname
    const isEnglish = window.location.hostname === 'en.beglaubigung24.de';
    this.errorMessages = {
      mixedShipping: isEnglish ?
        'You cannot combine products with different delivery options. Please select either "PDF only (digital)" or "PDF & original by post" for all documents.' :
        'Sie können keine Produkte mit verschiedenen Lieferoptionen kombinieren. Bitte wählen Sie für alle Dokumente entweder "Nur PDF (digital)" oder "PDF & Original per Post".',
      required: isEnglish ?
        'Please select a delivery option.' :
        'Bitte wählen Sie eine Lieferoption aus.'
    };
    // Initialize error state as false
    this.hasError = false;
  }

  /**
   * Toggle error styling and optionally display an inline error message.
   * Also scrolls the shipping selection area into view.
   * @param {boolean} hasError - Whether an error is present
   * @param {string} [message=''] - Optional error message to display
   */
  toggleErrorState(hasError, message = '') {
    const shippingSelect = document.querySelector('.label-3');
    const shippingLabel = shippingSelect?.closest('.product-form__input')?.querySelector('.form__label');

    if (shippingLabel) {
      shippingLabel.style.color = hasError ? '#C44E47' : '';
    }

    if (shippingSelect) {
      shippingSelect.style.backgroundColor = hasError ? '#ffaca8' : '';
    }

    // Display error message and scroll into view if error is active
    const shippingContainer = shippingSelect ? shippingSelect.closest('.select') : null;
    if (hasError && shippingContainer) {
      // Scroll so that the shipping area is in view
      shippingContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      
      // Create or update the error message element
      let errorEl = document.getElementById('shipping-error-message');
      if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.id = 'shipping-error-message';
        errorEl.style.color = '#C44E47';
        errorEl.style.fontSize = '0.8em';
        errorEl.style.marginTop = '0.5em';
        errorEl.style.lineHeight = '1';
        shippingContainer.parentNode.insertBefore(errorEl, shippingContainer.nextSibling);
      }
      // Use innerHTML to allow bold formatting within the error message
      errorEl.innerHTML = message;
    } else {
      // Remove the error message element if it exists
      const existingErrorEl = document.getElementById('shipping-error-message');
      if (existingErrorEl) {
        existingErrorEl.remove();
      }
    }

    this.hasError = hasError;
  }

  // Method to clear any existing error state
  clearErrorState() {
    this.toggleErrorState(false);
  }

  /**
   * Get the currently selected shipping option from the form
   * @returns {string|null} The selected shipping option or null if none selected
   */
  getCurrentlySelectedShippingOption() {
    const shippingSelect = document.querySelector('.label-3');
    if (!shippingSelect) return null;
    
    const selectedOption = shippingSelect.value;
    return selectedOption && selectedOption !== 'Bitte auswählen' ? selectedOption : null;
  }

  /**
   * Validates the shipping option before adding a new item.
   * Throws an error (after applying error styling) if validation fails.
   */
  async validateBeforeAdd(cartItems, newItem) {
    console.log('CartValidator - Incoming validation request:');
    console.log('New item:', newItem);
    console.log('Current cart items:', cartItems);
    
    try {
      // Get the currently selected shipping option from the form
      const newDeliveryOption = this.getCurrentlySelectedShippingOption();
      console.log('Selected delivery option:', newDeliveryOption);
      
      // (1) Must choose a shipping option
      if (!newDeliveryOption) {
        console.log('No shipping option => blocking add');
        this.toggleErrorState(true, this.errorMessages.required);
        throw new Error(this.errorMessages.required);
      }

      // (2) Do not mix shipping options in the same cart
      if (cartItems && cartItems.length > 0) {
        for (const item of cartItems) {
          const itemDeliveryOption = item.properties?.Lieferoption || item.properties?.Versand;
          
          if (itemDeliveryOption && itemDeliveryOption !== newDeliveryOption) {
            console.log('Delivery option mismatch => blocking add');
            this.toggleErrorState(true, this.errorMessages.mixedShipping);
            throw new Error(this.errorMessages.mixedShipping);
          }
        }
      }

      // If we reach here, validation passes
      console.log('CartValidator - Validation passed. Proceed with add.');
      this.clearErrorState();
      return true;

    } catch (error) {
      this.toggleErrorState(true, error.message);
      throw error;
    }
  }
}

// Create a global instance so product-form.js can call it
window.cartValidator = new CartValidator();

// Event listener to clear error state when the shipping option changes
document.addEventListener('DOMContentLoaded', function() {
  const shippingSelect = document.querySelector('.label-3');
  if (shippingSelect) {
    shippingSelect.addEventListener('change', function() {
      if (window.cartValidator && this.value && this.value !== 'Bitte auswählen') {
        window.cartValidator.clearErrorState();
      }
    });
  }
});